module.exports = __webpack_public_path__ + "img/blockshape_i.29aefac7.png";